import { useCallback } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

export enum EventName {
	BonusStart = 'Monarch Giving Box Start',
	BonusSubmit = 'Monarch Giving Box Submit',
}

enum Events {
	RecognitionGiven = 'Recognition Given',
}

export const useBonusBoxAnalytics = () => {
	const { track, trackEvent } = useAnalytics();

	const trackBonusStart = useCallback(() => {
		track(EventName.BonusStart);
	}, [track]);

	const trackSubmitFailure = useCallback(
		(eventProps?: any) => {
			track(EventName.BonusSubmit, {
				...eventProps,
				result: 'failure',
			});
		},
		[track]
	);

	const trackSubmitSuccess = useCallback(
		(eventProps: any) => {
			track(EventName.BonusSubmit, {
				...eventProps,
				result: 'success',
			});
			trackEvent(Events.RecognitionGiven, eventProps);
		},
		[track, trackEvent]
	);

	return { trackBonusStart, trackSubmitFailure, trackSubmitSuccess };
};
